@if (conversation()) {
    @let customerName = customerDetails$ | async;

    <div class="voice-notification mt-2 ms-2 container-fluid w-auto">
        <div class="row ms-0 mt-4">
            @if (workItem()?.isEnquiryCall) {
                <div
                    class="col-2 pt-2"
                    data-testid="voice-notification_enquiry-call-contact-icon"
                >
                    @let agent = agentName();
                    <telxl-contact-icon
                        [fullName]="
                            !agent || agent === 'Unknown agent' ? '?' : agent
                        "
                        [contactType]="contactUserOptions.Green"
                        [size]="contactUserSizes.Medium"
                    />
                </div>
                <div class="col-10 ps-3">
                    <div class="d-flex flex-column justify-content-between">
                        <div
                            class="font-xs w-100 align-self-end notification-text"
                            data-testid="voice-notification_enquiry-call-type"
                        >
                            Enquiry Call:
                        </div>
                        <div
                            class="font-xxl weight-medium cli"
                            data-testid="voice-notification_enquiry-call-agent-name"
                        >
                            {{ agentName() }}
                        </div>
                        <div
                            class="font-xl notification-text"
                            data-testid="voice-notification_enquiry-call-timeout"
                        >
                            {{ elapsedTime() | formatDuration }}
                        </div>
                    </div>
                </div>
            } @else {
                <div
                    class="col-2 pt-2"
                    data-testid="voice-notification_contact-icon"
                >
                    <telxl-contact-icon
                        [fullName]="
                            customerName === 'Unknown' || !customerName
                                ? '?'
                                : customerName
                        "
                        [contactType]="contactUserOptions.Green"
                        [size]="contactUserSizes.Medium"
                    />
                </div>
                <div class="col-10 ps-3">
                    <div class="d-flex flex-column justify-content-between">
                        <div
                            class="font-xs w-100 align-self-end notification-text"
                            data-testid="voice-notification_call-type"
                        >
                            Incoming CLI
                        </div>
                        <div
                            class="font-xxl weight-medium cli"
                            data-testid="voice-notification_from-number"
                        >
                            {{ conversation()?.fromNumber }}
                        </div>
                        <div
                            class="font-lg notification-text"
                            data-testid="voice-notification_customer-name"
                        >
                            {{ customerName }}
                        </div>
                        <div
                            class="font-xl notification-text"
                            data-testid="voice-notification_timeout"
                        >
                            {{ elapsedTime() | formatDuration }}
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="row ms-0 notification-text">
            <div class="col-2"></div>
            <div class="col-10 mt-1 ps-3 pe-0">
                <div class="d-flex flex-row"></div>

                <div class="d-flex align-items-start mt-3 mb-3">
                    <div class="flex-grow-1">
                        @if (workItem()?.isEnquiryCall) {
                            <div class="d-flex align-items-center">
                                <div class="col-4 font-xs me-1">
                                    Customer Name:
                                </div>
                                <div
                                    class="col-8 font-sm"
                                    data-testid="voice-notification_enquiry-call-customer-name"
                                >
                                    {{ customerName }}
                                </div>
                            </div>
                        }
                        <div class="d-flex align-items-center">
                            <div class="col-4 font-xs me-1">
                                Number dialled:
                            </div>
                            <div
                                class="col-8 font-sm"
                                data-testid="voice-notification_dialed-number"
                            >
                                {{
                                    conversation()?.dialedNumber | removebraces
                                }}
                            </div>
                        </div>
                        @if (!conversation()?.isInternalCall) {
                            <div class="d-flex align-items-center">
                                <div class="col-4 font-xs me-1">
                                    Queue name:
                                </div>
                                <div
                                    class="col-8 font-sm voice-detail"
                                    data-testid="voice-notification_queue-name"
                                >
                                    <telxl-truncate-text
                                        [text]="conversation()?.queueName"
                                        [useToolTip]="true"
                                    />
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="col-4 font-xs me-1">
                                    Service name:
                                </div>
                                <div
                                    class="col-8 font-sm voice-detail"
                                    data-testid="voice-notification_service-name"
                                >
                                    <telxl-truncate-text
                                        [text]="conversation()?.serviceName"
                                        [useToolTip]="true"
                                    />
                                </div>
                            </div>
                        }
                        <div class="d-flex align-items-center">
                            <div class="col-4 font-xs me-1">Call ID:</div>
                            <div
                                class="col-8 font-sm"
                                data-testid="voice-notification_voice-call-id"
                            >
                                {{ conversation()?.voiceCallId }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex pt-3 pb-2">
                    <div
                        class="d-flex flex-column align-items-center justify-content-center me-3 btn-accept-container"
                    >
                        <button
                            data-testid="voice-notification_accept"
                            type="button"
                            class="btn btn-accept rounded-circle p-3"
                            (click)="onAcceptClick()"
                        >
                            <i class="fa-xl fa-solid fa-phone"></i>
                        </button>
                        <div class="mt-2 font-sm text-center accept-label">
                            Accept
                        </div>
                    </div>

                    <div
                        class="d-flex flex-column align-items-center justify-content-center ms-4 btn-reject-container"
                    >
                        <button
                            data-testid="voice-notification_reject"
                            type="button"
                            class="btn btn-reject rounded-circle p-3"
                            (click)="onRejectClick()"
                        >
                            <i class="fa-xl fa-solid fa-phone-hangup"></i>
                        </button>
                        <div class="mt-2 font-sm text-center reject-label">
                            Reject
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 p-0">
                <div
                    class="progress-bar progress-voice"
                    [ngClass]="{
                        'bg-success': progress() > 66,
                        'bg-warning': progress() > 33 && progress() <= 66,
                        'bg-danger': progress() <= 33,
                    }"
                    role="progressbar"
                    [style.width]="progress() + '%'"
                ></div>
            </div>
        </div>
    </div>
}
